export const ACCESS_CONTROL_EVENT_FIELDS = [
	'occurred_at',
	'device_label',
	'user_label',
	'method',
	'status',
	'door_status',
	'reader_id',
	'match_route',
	'source_label',
	'evidence_label',
]

const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== ''

const text = (key, translate) => typeof translate === 'function' ? translate(key) : key

const displayValue = (value, emptyLabel) => hasValue(value) ? value : emptyLabel

const pad = value => String(value).padStart(2, '0')

const dateLabel = (value, emptyLabel) => {
	if (!hasValue(value)) return emptyLabel
	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return value
	return [
		date.getFullYear(),
		pad(date.getMonth() + 1),
		pad(date.getDate()),
	].join('-') + ' ' + [
		pad(date.getHours()),
		pad(date.getMinutes()),
		pad(date.getSeconds()),
	].join(':')
}

const methodLabel = (value, translate, emptyLabel) => {
	if (!hasValue(value)) return emptyLabel
	if (String(value) === 'faceOrFpOrCardOrPw') return text('access_method_face_fp_card_pw', translate)
	return value
}

export const isSuccessfulAccessEvent = (event = {}) => {
	return event.code === 'AccessControl' && ['1', 'granted'].includes(String(event.status).toLowerCase())
}

export const isDeniedAccessEvent = (event = {}) => {
	return event.code === 'AccessControl' && ['0', 'denied'].includes(String(event.status).toLowerCase())
}

export const isDoorStatusEvent = (event = {}) => {
	return event.code === 'DoorStatus' && ['Open', 'Close'].includes(event.door_status)
}

export const formatAccessControlEvent = (event = {}, translate) => {
	const emptyLabel = text('n_a', translate) || 'N/A'
	const formatted = {}

	ACCESS_CONTROL_EVENT_FIELDS.forEach((field) => {
		formatted[field] = displayValue(event[field], emptyLabel)
	})

	formatted.raw_status = event.status
	formatted.raw_snap_path = event.snap_path
	formatted.is_example = !!event.is_example
	formatted.is_successful_access = isSuccessfulAccessEvent(event)
	formatted.is_denied_access = isDeniedAccessEvent(event)
	formatted.is_door_status = isDoorStatusEvent(event)
	formatted.access_status_color = formatted.is_successful_access ? 'success' : 'error'

	if (event.code === 'AccessControl') {
		if (formatted.is_successful_access) {
			formatted.status = text('successful_access', translate)
		} else if (isDeniedAccessEvent(event)) {
			formatted.status = text('access_denied', translate)
		} else {
			formatted.status = displayValue(event.status, text('unknown_access', translate) || emptyLabel)
		}
	}

	if (event.code === 'DoorStatus') {
		if (event.door_status === 'Open') {
			formatted.door_status = text('door_open', translate)
		} else if (event.door_status === 'Close') {
			formatted.door_status = text('door_closed', translate)
		}
	}

	formatted.id = event.id || event.raw_id || [
		event.code || 'access_control',
		event.occurred_at || event.createdAt || '',
		event.user_id || '',
		event.device_sn || '',
	].join('-')
	formatted.occurred_at = dateLabel(event.occurred_at || event.createdAt, emptyLabel)
	formatted.method = methodLabel(event.method, translate, emptyLabel)
	formatted.deviceId = event.deviceId
	formatted.device_label = displayValue(event.deviceId || event.device_sn || event.deviceSn, emptyLabel)
	formatted.user_label = displayValue(event.user_name || event.user_id, emptyLabel)
	formatted.match_route = displayValue(event.matched || event.route_key || event.path, emptyLabel)
	formatted.source_label = displayValue(event.source_ip || event.http_method, emptyLabel)
	formatted.evidence_label = hasValue(event.snap_path) ? text('evidence_available', translate) : text('no_evidence', translate)

	return formatted
}
